import { render, staticRenderFns } from "./MyPortalTable.vue?vue&type=template&id=3d7ab0ed&"
import script from "./MyPortalTable.vue?vue&type=script&lang=js&"
export * from "./MyPortalTable.vue?vue&type=script&lang=js&"
import style0 from "./MyPortalTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports